'use strict'

import React from 'react';
import Layout from './Layout.jsx';

class Header extends React.Component {
  render() {
    return (
      <div style={{paddingTop:5, paddingBottom:5, fontWeight:"bold", fontFamily:"Lato, Arial, Helvetica Neue, Helvetica, sans-serif", background:"#FFFFFF", textAlign:"left", color:"#212121", fontSize:20, textTransform:"capitalize", paddingLeft:2}}>
        {this.props.title}
      </div>
    );
  }
}

class Option extends React.Component {
  constructor(props) {
    super(props);
    this.state={value:props.value}
  }

  changeValue(event) {
    const newValue=event.target.checked;
    this.setState({value:newValue}
      ,this.props.onChange!==undefined
        ? ()=>this.props.onChange(this.props.property,this.props.id,newValue) : undefined
    );
  }

  render() {
    return (
      <div style={{paddingLeft:2}}>
      <label className="checkboxcontainer"> {this.props.label}
        <input className="checkbox"
          name={this.props.name}
          type="checkbox"
          id={this.props.id}
          checked={this.state.value}
          onChange={this.changeValue.bind(this)}
        />
        <span className="checkmark"></span>
      </label>
      </div>
    );
  }
}

export class FilterOptions extends React.Component {
  pluralName(propertyName) {
    return propertyName.slice(-1)==="y" ? propertyName.slice(0,-1)+"ies" : propertyName+"s";
  }

  labelForProperty(propertyName) {
    return propertyName==="projectType" ? "type" : propertyName;
  }

  render() {
    let filter=this.props.filter;
    let tenant=this.props.tenant;
    return (
      <div style={{display:"flex", justifyContent: "flex-start", flexWrap: "wrap"}}>
        <div style={{marginRight:15, paddingBottom:15}}>
          <Header title="State"/>
          {["started", "paused","stopped","completed"].map(state=>(
            <Option
              key={"state_"+state}
              property="state"
              name={"state_"+state}
              id={state}
              value={filter===undefined || filter["state"+"_"+state]===undefined || filter["state"+"_"+state]!==false}
              label={state.slice(0,1).toUpperCase()+state.slice(1)}
              onChange={this.props.onChange}
            />
          ))}
        </div>
        {(this.props.exclude!==undefined && this.props.exclude.includes("portfolio") ? [] : ["portfolio"])
          .concat(["location", "projectType", "department", "category"]).map(property=>(
          <div key={property} style={{marginRight:15, paddingBottom:15}}>
            {tenant[this.pluralName(property)]!==undefined && tenant[this.pluralName(property)].length>0 ? (
              <div>
                <Header title={this.labelForProperty(property)}/>
                {tenant[this.pluralName(property)].map(item=>(
                  <Option
                    key={item.id}
                    property={property}
                    name={property+"_"+item.id}
                    id={item.id}
                    value={filter===undefined || filter[property+"_"+item.id]===undefined || filter[property+"_"+item.id]!==false}
                    label={item.name}
                    onChange={this.props.onChange}
                  />
                ))}
              </div>
            ) : null}
          </div>
        ))}

        {tenant.projects!==undefined ? ["phase"].map(property=>(
          <div key={property} style={{marginRight:15, paddingBottom:15}}>
            <div>
              <Header title={this.labelForProperty(property)}/>
              {tenant.projects.map(project=>project[property]).filter((value,index,array)=> array.indexOf(value)===index).sort((a,b)=>a<b ? -1 : a>b ? 1 : 0).map(item=>(
                <Option
                  key={property+"_"+item}
                  property={property}
                  name={property+"_"+Buffer.from(item).toString("base64")}
                  id={property+"_"+Buffer.from(item).toString("base64")}
                  value={filter===undefined || filter[property+"_"+Buffer.from(item).toString("base64")]===undefined || filter[property+"_"+Buffer.from(item).toString("base64")]!==false}
                  label={item}
                  onChange={this.props.onChange}
                />
              ))}
            </div>
          </div>
        )) : null}
        {this.props.options!==undefined ? Object.keys(this.props.options).map(property=>(
          <div key={property} style={{marginRight:15, paddingBottom:15}}>
            <Header title={property.slice(0,1).toUpperCase()+property.slice(1)}/>
            {this.props.options[property].map(item=>(
              <Option
                key={property+"_"+item.id}
                property={property}
                name={property+"_"+item.id}
                id={item.id}
                value={filter===undefined || filter[property+"_"+item.id]===undefined || filter[property+"_"+item.id]!==false}
                label={item.name}
                onChange={this.props.onChange}
              />
            ))}
          </div>
        )) : null}
      </div>
    );
  }
}

class Filter extends React.Component {

  //Duplicated from AccountCreated.jsx

  render() {
    var tenant=this.props.tenant;
    var filter=this.props.user.filters!==undefined ? this.props.user.filters[this.props.tenant.id] : undefined;
    return (
      <div style={{textAlign: "left", fontFamily: "Lato", marginLeft:30, display:"flex"}}>
        <div style={{maxWidth:1016, textAlign:"left"}}>
          <div style={{paddingTop:30, paddingBottom:25, fontWeight:"bold", fontFamily:"Lato, Arial, Helvetica Neue, Helvetica, sans-serif", background:"#FFFFFF", textAlign:"left", color:"#212121", fontSize:28, textTransform:"capitalize"}}>
             Filter projects
          </div>
          <form method="POST" action="/filter">
            <FilterOptions filter={filter} tenant={tenant}/>
            <div style={{paddingTop:20}}>
              <div style={{float:"right"}}>
                <input className="cancel" type="submit" name="cancel" value="Cancel"/>
                <span style={{paddingRight:30}}> </span>
                <input className="save" type="submit" value="Apply filter"/>
              </div>
              <div>
                <a href="/filter/reset"><b>Reset filter</b></a>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default class FilterPage extends React.Component {
  render() {
    return (
      <Layout {...this.props}>
        <Filter {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/Filter.jsx